// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2VYMO","footer":"ChangeClinic_footer__1TB7I"};